import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '@b2b/features/product/core/utilities/product.model';

@Component({ template: '' })
export abstract class ProductTabComponent {
  @Input() product!: Product;
  @Input() isActive = false;
  @Output() statusChange = new EventEmitter<boolean>();

  changeStatus() {
    this.isActive = !this.isActive;
    this.statusChange.next(this.isActive);
  }
}
